import React from 'react'
import { Row } from '@tanstack/react-table'
import { useGetSalePathsUserPath } from '../../../api/dealership/performance/salePaths/useGetSalePathsUserPath'
import classNames from 'classnames'
import { CustomerRow } from '../../../lib/types/CustomerRow'
import { ReactComponent as PerformanceCPUserPathStart } from '../../../images/performance/performance-cp-user-start.svg'
import { ReactComponent as PerformanceCPLineTo } from '../../../images/performance/performance-cp-line-to.svg'
import { ReactComponent as IconUserPath } from '../../../images/performance/icon_user_path.svg'
import LeadPathStep from '../LeadPaths/LeadPathStep/LeadPathStep'
import { useDealership } from '../../../store/zustand/dealershipStore'
import SalesEventStep from './SalesEventStep'
import { useTranslation } from 'react-i18next'

const SalesUserPath = ({ row }: { row: Row<CustomerRow> }) => {
  const dealership = useDealership()
  const { t } = useTranslation('pages', {
    keyPrefix: `performance.salePaths.${dealership?.industry || 'automotive'}`,
  })

  const {
    data: userPath,
    isLoading: isLoadingUserPath,
    isPreviousData: isPreviousDataUserPath,
  } = useGetSalePathsUserPath({
    filters: {
      customer_id: row.original.customer_id,
      event_date: row.original.sale_date,
    },
  })

  return (
    <div
      className={classNames(
        'bg-primary-persian-blue/10 p-5 w-screen rounded-md flex flex-col gap-5',
        {
          'opacity-50': isPreviousDataUserPath || isLoadingUserPath,
        },
      )}>
      <div className={'flex flex-row gap-2 items-center'}>
        <IconUserPath />
        <h3 className={'font-bold text-base'}>User path</h3>
      </div>
      <div className={'flex flex-row items-center justify-center gap-8'}>
        <div className={'flex items-center overflow-x-scroll w-screen pb-4'}>
          <div
            className={
              'bg-white border-2 border-primary-xiketic rounded-2xl p-5 items-center flex flex-col justify-center gap-3 min-w-fit'
            }>
            <PerformanceCPUserPathStart />
            <div className={'mx-auto text-center'}>
              <h3 className={'text-primary-xiketic font-bold text-sm'}>User</h3>
            </div>
          </div>

          <div className="flex items-center">
            {userPath?.userPath?.map((path, index, array) => {
              return (
                <div key={index} className={'flex items-center'}>
                  <div className={'-ml-0.5 -mr-2'}>
                    <PerformanceCPLineTo
                      className={index % 2 === 0 ? '-scale-y-100' : ''}
                    />
                  </div>
                  {index < array.length && <LeadPathStep path={path} />}
                </div>
              )
            })}
            <div className={'-ml-0.5 -mr-2'}>
              <PerformanceCPLineTo className={'-scale-y-100'} />
            </div>
            <SalesEventStep
              industry={dealership?.industry}
              path={{
                Time: row.original.sale_date,
                Title: t('sale_event'),
                VIN: row.original.vin,
                Vehicle: `${Boolean(row.original.year) ? row.original.year : ''} ${
                  row.original.make ? row.original.make : ''
                } ${row.original.model ? row.original.model : ''}`,
              }}
            />
          </div>
        </div>
      </div>
    </div>
  )
}

export default SalesUserPath
